"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Versioning = void 0;
const versioningGetVersionVersionGet_js_1 = require("../funcs/versioningGetVersionVersionGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Versioning extends sdks_js_1.ClientSDK {
    /**
     * Get Version
     *
     * @remarks
     * Get the current version of Kraken.
     *
     * A human-readable message, a semantic version string and a semantic version object are returned.
     */
    async getVersionVersionGet(options) {
        return (0, fp_js_1.unwrapAsync)((0, versioningGetVersionVersionGet_js_1.versioningGetVersionVersionGet)(this, options));
    }
}
exports.Versioning = Versioning;
//# sourceMappingURL=versioning.js.map